module.exports = __webpack_public_path__ + "static/media/lastPageIcon.eb01455b.svg";